/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AvailabilityInput {
  available_now = "available_now",
  preorder = "preorder",
  trunkshow = "trunkshow",
}

export enum Gender {
  men = "men",
  women = "women",
}

export enum TextAlignType {
  center = "center",
  left = "left",
  right = "right",
}

export interface PriceRange {
  min?: number | null;
  max?: number | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
